/** 读取 position/total 数值字段，非法则 0 */
export function readPositionTotalField(pos, key) {
  const num = Number(pos?.[key]);
  return Number.isFinite(num) ? num : 0;
}

export function readPlatformAvailable(balanceRes) {
  const platformAvailable = Number(balanceRes?.available ?? 0);
  return Number.isFinite(platformAvailable) ? platformAvailable : 0;
}

export function readPlatformTotal(balanceRes) {
  const total = Number(balanceRes?.total ?? balanceRes?.available ?? 0);
  return Number.isFinite(total) ? total : 0;
}

/** 双桶开启时：主 DUSD + 活动金 ACTIVITY_DUSD 可用合计（对齐 Go AvailableCollateralSum） */
export function readCombinedCollateralAvailable(balancesRes) {
  const dusd = Number(balancesRes?.dusd ?? balancesRes?.DUSD ?? 0);
  const activity = Number(
    balancesRes?.activityDusd ?? balancesRes?.activity_dusd ?? balancesRes?.ACTIVITY_DUSD ?? 0
  );
  const sum = (Number.isFinite(dusd) ? dusd : 0) + (Number.isFinite(activity) ? activity : 0);
  return sum;
}

/**
 * 导航栏 / 账户页总资产（对接指南 §1.1）
 * 现金优先 platformTotal（应已含 DUSD+ACTIVITY_DUSD 可用，及已知冻结）；
 * 若 total 缺失则回落 platformAvailable（双桶合计）。
 * 总资产 = 平台现金 + 持仓市值；界面展示 USD。
 * @param {{ platformAvailable?: number|null, platformTotal?: number|null, positionTotal: object|null }} input
 */
export function computePortfolioTotalAssets(input) {
  const available = Number(input.platformAvailable);
  const total = Number(input.platformTotal);
  // 双桶场景：若 total 仍是旧 DUSD-only（小于 available），以 available 为准，避免总资产漏体验金。
  let cash = 0;
  if (Number.isFinite(total) && Number.isFinite(available) && available > total + 1e-9) {
    cash = available;
  } else if (Number.isFinite(total)) {
    cash = total;
  } else if (Number.isFinite(available)) {
    cash = available;
  }
  const positionValue = readPositionTotalField(input.positionTotal, 'totalValue');
  return cash + positionValue;
}

/**
 * 余额（可用）：优先平台 DUSD available；无账本时 0（不再用链上 USDC 冒充交易余额）
 * @param {{ platformAvailable?: number|null }} input
 */
export function computePlatformAvailableDisplay(input) {
  const platform = Number(input.platformAvailable);
  if (Number.isFinite(platform)) return platform;
  return 0;
}
